var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['suggestions-subnav', !_vm.inDashboard && 'suggestions-subnav-padded']},_vm._l((_vm.navMap),function(ref){
var mode = ref.mode;
var label = ref.label;
return _c('RouterLink',{key:mode,attrs:{"to":(_vm.currentPath + "/" + mode),"tag":"span","replace":""}},[_c('button',{staticClass:"btn filter-btn",class:{ 'filter-btn-active': mode === _vm.activeMode, 'filter-btn-inactive': mode !== _vm.activeMode }},[_vm._v(_vm._s(label))])])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }